import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";
import { createTechStack } from "./api";
import { invalidateAllQueries } from "utils/utils";

function buildPayload(values) {
  if (!values || typeof values !== "object") return {};
  console.log(values);
  return {
    ...Object.fromEntries(
      Object.entries(values).filter(
        ([_, v]) => v !== "" && v !== undefined && v !== null
      )
    ),
  };
}

export function useCreateTechStack() {
  return useMutation({
    mutationFn: async ({ item }) => {
      const payload = buildPayload(item);
      const response = await createTechStack({ item: payload });
      return response;
    },
    onSuccess: () => {
      toast.success("Tech Stack Created Successfully");
      invalidateAllQueries();
    },
    onError: (error) => {
      toast.error(error.message);
      console.log(error.message);
    },
  });
}
